import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useEnvironment } from '../contexts/EnvironmentContext';

export const EnvironmentBanner: React.FC = () => {
    const { environment, loading } = useEnvironment();

    if (loading || environment !== 'development') {
        return null;
    }

    return (
        <div className="bg-yellow-500 text-white py-2 px-4 flex items-center justify-center gap-2 shadow-md">
            <AlertTriangle className="w-5 h-5" />
            <span className="font-semibold text-sm uppercase">Ambiente de Desenvolvimento</span>
        </div>
    );
};




